
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","d":"M11.57 11.73a4.49 4.49 0 000 6.36 4.508 4.508 0 005.57.63l2.933 2.896a.25.25 0 00.353-.002l1.038-1.038a.25.25 0 000-.353L18.55 17.29c1.13-1.77.87-4.09-.62-5.57a4.49 4.49 0 00-6.36.01zm4.95 4.94c-.98.98-2.56.97-3.54 0-.97-.98-.97-2.56.01-3.54.97-.97 2.55-.97 3.53 0 .97.98.97 2.56 0 3.54m-6.37 2.83a6.527 6.527 0 01-1.48-2.32c-3.15-.53-5.42-2.02-5.42-3.78v3c0 2.21 3.58 4 8 4-.4-.26-.77-.56-1.1-.9M3.25 8.4v3c0 1.68 2.07 3.12 5 3.7v-.2c0-.93.2-1.85.58-2.69-3.24-.51-5.58-2.02-5.58-3.81m8-6c-4.42 0-8 1.79-8 4 0 2 3 3.68 6.85 4h.05c1.2-1.26 2.86-2 4.6-2 .91 0 1.81.19 2.64.56a3.215 3.215 0 001.86-2.56c0-2.21-3.58-4-8-4z","opacity":".75"}})])
          )
        }
      }
    